export enum LoginMethodEnum {
  Google = 'google',
  Email = 'email',
  Passkey = 'passkey',
}
